exports.routePrefix = {
  summary: 'summary',
  risk: 'risk',
  search: 'search',
  manualEntry: 'manualEntry',
  personalInformation: 'personalInformation',
  care: 'care',
  breakGlass: 'break-glass',
  authorize: 'authorize',
  document: 'patient-documents',
  timeTracker: 'time-tracker',
  carePlan: 'care-plans',
  communityResource: 'community-resource',
};

exports.factoryService = {
  v1: 'nadan',
  v2: 'inapi',
  incare: 'incare',
};
